import { envToBoolean } from './utils';

export const SHOW_OGI_NEAR_RASTER_COORDINATES = envToBoolean(process.env.NEXT_PUBLIC_SHOW_OGI_NEAR_RASTER_COORDINATES);
